<script context="module">
    import { apiMethods } from "../../../Services/index.svelte";

    import { goToURL, showError } from "../../../Utils/utilFunctions.svelte";

    export const openTabForSSO = async (id, domain, goTo = "") => {
        await apiMethods.putMethod
            .getSingleSignOnToken({ id, domain })
            .then((res) => {
                if (!res || res.error)
                    showError(res.error ?? "Failed to get SSO token");
                else {
                    let redirectURL = `https://${domain}/?sso=${res.token}${goTo ? `&go=${goTo}` : ""}`;

                    window.open(redirectURL, "_blank");
                }
            })
            .catch((err) => {
                showError(err);
            });
    };
</script>
